import { Modal, Header, ModalContent } from './styles'
import CloseButton from 'src/global/CloseButton'
import { Backdrop } from 'src/global'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { State } from 'src/state'
import { Screen } from 'src/screens'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLink } from '@fortawesome/free-solid-svg-icons'
import useWindowModal from 'src/helpers/useWindowModal'

const tutorialUrl = 'https://www.meniudigital.ro/blog/cum-sa-primesti-comenzi-online-meniudigital'
const feedbackSurveyBaseUrl =
  'https://docs.google.com/forms/d/e/1FAIpQLSdU6Yjh75WXM7o2gPnMrQQYMKmjEmWR5gcn5kSvf3hu9QUq4w/viewform?usp=pp_url&entry.441883612='

export default function OnlineOrderingInfoModal() {
  const { isOpen, close } = useWindowModal('online-ordering-info-modal:change', (openModal, closeModal) => {
    window.openOnlineOrderingInfoModal = openModal
    window.hideOnlineOrderingInfoModal = closeModal
  })
  const navigate = useNavigate()
  const { user } = useSelector((state: State) => state.users)

  const openExternal = (url: string) => {
    if (!url) {
      return
    }
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const goToConsumerOrders = () => {
    navigate(Screen.ConsumerOrders)
    close()
  }

  const openFeedbackSurvey = () => {
    window.open(`${feedbackSurveyBaseUrl}${encodeURIComponent(user?.username || '')}`, '_blank', 'noopener,noreferrer')
  }

  return (
    <>
      <Backdrop onClick={close} className={isOpen ? 'open' : 'closed'} />
      <Modal className={isOpen ? 'open' : 'closed'}>
        <Header>
          <div className="title-wrapper">
            <div className="title">Comenzi Online prin MeniuDigital</div>
          </div>
          <CloseButton onClick={close} title="Închide" color="#ffffff" style={{ marginTop: '-16px', marginRight: '-9px' }} />
        </Header>
        <ModalContent>
          <section className="section">
            <p>
              Sistemul de comenzi online prin MeniuDigital.ro permite clienților tăi să plaseze comenzi direct din meniul digital,
              ca alternativă pentru comenzile telefonice sau site-ul propriu.
            </p>
          </section>

          <section className="section">
            <h3>De unde îl activez?</h3>
            <p>
              Sistemul este disponibil în{' '}
              <span className="inline-link" onClick={goToConsumerOrders}>
                secțiunea Comenzi
              </span>
              . Aici găsești panoul de configurare cu pașii necesari: setezi locația, programul de lucru, zonele de livrare,
              adaugi ospătari și distribui link-ul meniului. Pe măsură ce bifezi pașii, sistemul devine pe deplin funcțional.
            </p>
            <img className="screenshot" src="/ordering-with-delivery.jpeg" alt="Comutator Cu Livrare în pagina Comenzi" />
          </section>

          <section className="section">
            <h3>Cum îl configurez?</h3>
            <p>
              Am pregătit un ghid complet care îți arată pas cu pas cum configurezi zonele de livrare, programul, taxele și restul
              setărilor relevante. Tot acolo găsești răspunsuri la întrebările și neclaritățile pe care le-ai putea avea.
            </p>
            <button className="link-btn" onClick={() => openExternal(tutorialUrl)}>
              Deschide Ghidul
              <FontAwesomeIcon icon={faExternalLink} />
            </button>
          </section>

          <section className="section">
            <h3>Cum comandă clienții?</h3>
            <p>
              Experiența este similară unui website propriu de comenzi: clientul accesează meniul prin link sau cod QR și comandă
              direct. Recomandăm să plasezi întâi o comandă de probă, apoi să distribui link-ul către clienți.
            </p>
            <img className="screenshot narrow" src="/copy-link.jpeg" alt="Buton Copiază link meniu" />
          </section>

          <section className="section">
            <h3>Cât costă?</h3>
            <p>Comenzile generate prin meniul web sunt incluse în abonament.</p>
            <p>
              Indiferent dacă provin din link direct, Facebook, Google Maps sau alte canale promovate de tine,{' '}
              <strong>nu comisionăm clienții tăi</strong>, deci poți muta gratuit comenzile telefonice/website direct în meniul
              digital.
            </p>
            <p className="note">Notă: plățile online cu cardul vor fi comisionate separat de către procesatorul de plăți.</p>
            <p>
              Pe viitor, dacă vom lansa și promova aplicația MeniuDigital pentru clienții finali, sistemul va funcționa pe bază de afiliere,
              cu un comision de 3-4x mai mic decât agregatorii actuali pentru comenzile aduse prin aplicație.
            </p>
          </section>

          <section className="section">
            <h3>Oferă feedback</h3>
            <p>Spune-ne ce ți-a lipsit cel mai mult, ce a mers bine și ce ai vrea să mai adăugăm.</p>
            <button className="link-btn" onClick={openFeedbackSurvey}>
              Completează Formularul
              <FontAwesomeIcon icon={faExternalLink} />
            </button>
          </section>
        </ModalContent>
      </Modal>
    </>
  )
}
